import * as React from 'react';
import { ReactElement, useEffect, useState } from 'react';

export interface LazyVisibleProps {
    children: ReactElement<{ visible: boolean }>;
}

const POPUP_ANIMATION_TIMEOUT = 200;

export function LazyVisible(props: LazyVisibleProps) {
    const { children } = props;
    const [isVisible, setIsVisible] = useState(false);
    const [isRendered, setIsRendered] = useState(false);

    useEffect(() => {
        const isChildVisible = children.props.visible;
        let timeout: number;

        // если "отрисованность и видимость" в соответствии с props, ничего делать не нужно
        if (isChildVisible === isVisible && isChildVisible === isRendered) {
            return;
        }

        if (isChildVisible) {
            if (!isVisible) {
                if (!isRendered) {
                    setIsRendered(true); // сначала рисуем содержимое, но не показываем попап
                } else {
                    setIsVisible(true);
                }
            }
        } else {
            // если нужно закрыть - сначала прячем
            setIsVisible(false);
            // а после завершения анимации убираем содержимое насовсем
            timeout = window.setTimeout(() => {
                setIsRendered(false);
            }, POPUP_ANIMATION_TIMEOUT);
        }

        return () => {
            window.clearTimeout(timeout);
        };
    });

    if (!isRendered) {
        return null;
    }

    return React.cloneElement(children, {
        visible: isVisible
    });
}
